module.exports = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAEAAAABACAYAAACqaXHeAAAAdklEQVR42u3awQ0AIAgEweu/aSxBPxrUIdkG5kUCqar8XAAAAAAAAAAAAAAAALBWUq0DAAAAAAAAAPQFmA0AAAAAAAAA4F6A3QMAAAAAAAAAsAgBAAAAAAAAABxGAAAAAAAAAADnAHyKAgAAAAAAAAAAAADwQgNHBBZVTv+OOAAAAABJRU5ErkJggg=="


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/flags/Switzerland.png
// module id = 1Dm2
// module chunks = 0 62 63